import React from 'react';
import Dialog from 'material-ui/Dialog';
import Helper from '../utils/Helpers';
import Button from '@material-ui/core/Button';

let image = {
    verticalAlign: "middle",
    width: "2rem",
    height: "2rem",
    borderRadius: "50%",
}
let button = {
    margin: "1%",
    color: "green",
    borderColor: "green",
    width: "48%",
    height: "available",
    fontFamily: "Roboto",
    fontSize: "11px"
}

let background = {
    color: "whitesmoke",
    backgroundColor: "#375139"
}

let font = {
    fontFamily: "Roboto",
    color: "grey",
    width: "100%"
}

const FarmerInfoDialog = ({open,farmerImages,farmerProfile,produceFarming,farmerId,handleCancelDialog,fundFarmerRequest}) =>{
    return(
        <Dialog
        title={<h3 style={background} className="uk-modal-title">Full Farmer Profile
            | {farmerProfile.name + " " + farmerProfile.surname} <img alt="img"
                src="https://dashboard.khula.co.za/images/download.svg"/></h3>}
        modal={false}
        open={open}
        onRequestClose={() => handleCancelDialog("fullProfile")}
        // actions={actions}
        autoScrollBodyContent={true}>
        <div className="dialogcontainer">
            <div className="orderprice">
                {
                    farmerImages && 
                    <div className="row">
                        <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            {farmerImages.length > 0 && <img alt="img" src={farmerImages[0]}/>}
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <div className="row">
                                <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                    {farmerImages.length > 1 &&
                                    <img alt="img" src={farmerImages[1]}/>}
                                </div>
                                <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                    {farmerImages.length > 2 &&
                                    <img alt="img" src={farmerImages[2]}/>}
                                </div>
                                <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                    {farmerImages.length > 3 &&
                                    <img alt="img" src={farmerImages[3]}/>}
                                </div>
                                <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                    {farmerImages.length > 4 &&
                                    <img alt="img" src={farmerImages[4]}/>}
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <div className="farmerprofile-card-img">

                    <img alt="img" src={Helper.getFarmerImage(farmerProfile.image_name)}/>
                    <div className="farmerprofileproducts">
                        <h5 style={font}>PRODUCTS: <br/></h5>

                        {produceFarming.map((produce, i) =>

                            <div className="products">

                                <p><img alt="img" style={image}
                                        src={Helper.getImageName(produce.name)}/>{i + 1}: {produce.name}
                                </p>
                            </div>
                        )}
                    </div>

                </div>


                <div className="farmercontent row">

                    <div className="farmercontentcol farmercontentcol-item col-sm-6 col-md-2 col-lg-2 col-xl-2">
                        <div><img alt="img" src="https://dashboard.khula.co.za/images/tractor.png"/></div>
                        <div>Funding Needs:<br/> {farmerProfile.fundingFor} <Button
                                onClick={() => fundFarmerRequest(farmerId)}
                                style={button} variant="outlined">send voucher</Button></div>
                    </div>

                    <div className="farmercontentcol farmercontentcol-item col-sm-6 col-md-2 col-lg-2 col-xl-2">
                        <div><img alt="img" src="https://dashboard.khula.co.za/images/land.png"/></div>
                        <div>Farm Size:<br/> {farmerProfile.farmSize} hectares </div>
                    </div>
                    <div className="farmercontentcol farmercontentcol-item col-sm-6 col-md-2 col-lg-2 col-xl-2">
                        <div><img alt="img" src="https://dashboard.khula.co.za/images/vegetables.png"/></div>
                        <div>Produce Type:<br/> {farmerProfile.produceType}</div>
                    </div>
                    <div className="farmercontentcol farmercontentcol-item col-sm-6 col-md-2 col-lg-2 col-xl-2">
                        <div><img alt="img" src="https://dashboard.khula.co.za/images/bank.png"/></div>
                        <div>Estimated Revenue:<br/> R {farmerProfile.turnover}</div>
                    </div>
                    <div className="farmercontentcol farmercontentcol-item col-sm-6 col-md-2 col-lg-2 col-xl-2">
                        <div><img alt="img" src="https://dashboard.khula.co.za/images/experiment.png"/></div>
                        <div>Experience:<br/> {farmerProfile.experience} years
                        </div>
                    </div>
                    <div className="farmercontentcol farmercontentcol-item col-sm-6 col-md-2 col-lg-2 col-xl-2">
                        <div><img alt="img" src="https://dashboard.khula.co.za/images/land.png"/></div>
                        <div>Land Ownership:<br/> {farmerProfile.landOwnership}</div>
                    </div>
                    <div className="farmercontentcol farmercontentcol-item col-sm-6 col-md-2 col-lg-2 col-xl-2">
                        <div><img alt="img" src="https://dashboard.khula.co.za/images/diploma.png"/></div>
                        <div>Certification:<br/> {farmerProfile.certification}
                        </div>
                    </div>
                    <div className="farmercontentcol farmercontentcol-item col-sm-6 col-md-2 col-lg-2 col-xl-2">
                        <div><img alt="img" src="https://dashboard.khula.co.za/images/fields.png"/></div>
                        <div>Soil Test?:<br/> {farmerProfile.soilTest}</div>
                    </div>
                    <div className="farmercontentcol farmercontentcol-item col-sm-6 col-md-2 col-lg-2 col-xl-2">
                        <div><img alt="img" src="https://dashboard.khula.co.za/images/drop.png"/></div>
                        <div>Water Test:<br/> {farmerProfile.waterTesting}</div>
                    </div>
                    <div className="farmercontentcol farmercontentcol-item col-sm-6 col-md-2 col-lg-2 col-xl-2">
                        <div><img alt="img" src="https://dashboard.khula.co.za/images/drop.png"/></div>
                        <div>Water Source: <br/>{farmerProfile.waterType}</div>
                    </div>
                    <div className="farmercontentcol farmercontentcol-item col-sm-6 col-md-2 col-lg-2 col-xl-2">
                        <div><img alt="img" src="https://dashboard.khula.co.za/images/irrigation-system.png"/></div>
                        <div>Irrigation Type:<br/> {farmerProfile.irrigationType}</div>
                    </div>
                    <div className="farmercontentcol farmercontentcol-item col-sm-6 col-md-2 col-lg-2 col-xl-2">
                        <div><img alt="img" src="https://dashboard.khula.co.za/images/shovel.png"/></div>
                        <div>Infrastructure: <br/>{farmerProfile.farmType}
                        </div>
                    </div>


                </div>


            </div>
        </div>
    </Dialog>


    )
}

export default FarmerInfoDialog;


// WEBPACK FOOTER //
// ./src/components/FarmerInfoDialog.js